import assign from 'lodash.assign';
export class QualificationApplicationRequest {
    constructor(init) {
        assign(this, init);
    }
    ublExtensions;
    ublVersionID;
    customizationID;
    profileID;
    profileExecutionID;
    id;
    copyIndicator;
    uuid;
    contractFolderID;
    issueDate;
    issueTime;
    versionID;
    previousVersionID;
    procedureCode;
    qualificationApplicationTypeCode;
    weightScoringMethodologyNote;
    weightingTypeCode;
    contractingParty;
    procurementProject;
    procurementProjectLots;
    tenderingCriteria;
    additionalDocumentReferences;
    isProcurementDividedIntoLots;
}
